import { render, staticRenderFns } from "./tiscInput.vue?vue&type=template&id=1f70a81c&scoped=true&"
import script from "./tiscInput.vue?vue&type=script&lang=js&"
export * from "./tiscInput.vue?vue&type=script&lang=js&"
import style0 from "./tiscInput.vue?vue&type=style&index=0&id=1f70a81c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f70a81c",
  null
  
)

export default component.exports